module.exports = __webpack_public_path__ + "static/media/QR_APP.d38ed251.svg";